import React, { useState } from "react";
import "./PromoShowcaseAddonPreview.css";

const CARD_TYPES = {
  "Jersey & Apparel Builder": "jersey",
  "AI Client Store Generator": "store",
  "Campaign & Drop Manager": "campaign",
  "Advanced Product Personalization": "personalization",
  "Client Approval Workflows": "approval",
  "Program-Based Pricing Engine": "pricing",
  "Lead Capture & Conversion Tools": "leads",
  "Client Portal & Re-Order Hub": "reorder",
  "AI Sales & Merchandising Assistant": "assistant",
};

const MiniWindow = ({ title, label, children }) => (
  <div className="ps-addon-window">
    <div className="ps-addon-window-header">
      <strong>{title}</strong><span>{label}</span>
    </div>
    {children}
  </div>
);

const Jersey = () => (
  <MiniWindow title="TEAM UNIFORM BUILDER" label="LIVE PREVIEW">
    <div className="ps-addon-jersey-stage">
      <svg className="ps-addon-jersey" viewBox="0 0 160 116" role="img" aria-label="Jersey changes colour and gains player details">
        <path className="ps-addon-jersey-fabric" d="M48 10 61 4h38l13 6 37 25-21 26-15-9v59H47V52l-15 9L11 35Z" />
        <path d="M61 4Q80 25 99 4" fill="none" stroke="#e4eaf3" strokeWidth="6" />
        <path d="M49 49h63" fill="none" stroke="#ffffff" strokeOpacity=".32" strokeWidth="5" />
        <text x="80" y="44" textAnchor="middle" fontSize="9" fill="white" fontWeight="800">ELITE</text>
        <text className="ps-addon-jersey-number" x="80" y="83" textAnchor="middle" fontSize="34" fill="white" fontWeight="900">27</text>
      </svg>
      <div className="ps-addon-jersey-settings"><span>TEAM COLOUR</span><div className="ps-addon-swatches"><i/><i/><i/></div><span>PLAYER NAME</span><b className="ps-addon-typewriter">MORGAN</b><span>NUMBER</span><b>27</b></div>
    </div>
  </MiniWindow>
);

const Store = () => (
  <MiniWindow title="STORE GENERATOR" label="AI BUILD">
    <div className="ps-addon-store-banner"><span>YOUR BRAND</span><strong>Team collection</strong></div>
    <div className="ps-addon-product-row"><div className="ps-addon-product"><span>👕</span><i/></div><div className="ps-addon-product"><span>🧢</span><i/></div><div className="ps-addon-product"><span>🎒</span><i/></div></div>
    <div className="ps-addon-status">✦ Layout, products and branding generated</div>
  </MiniWindow>
);

const Campaign = () => (
  <MiniWindow title="CAMPAIGN SCHEDULE" label="OCT 2026">
    <div className="ps-addon-calendar" aria-label="Campaign week October 12 through 18, 2026">
      {["MON","TUE","WED","THU","FRI","SAT","SUN"].map((day, index) => (
        <div className={"ps-addon-calendar-day" + (index === 2 ? " ps-addon-calendar-launch" : "")} key={day}>
          <span>{day}</span><strong>{12 + index}</strong>
        </div>
      ))}
    </div>
    <div className="ps-addon-campaign-status"><span>Fall apparel drop</span><b>● LIVE</b></div>
    <div className="ps-addon-progress"><i/></div>
    <div className="ps-addon-mini-meta"><span>Pre-orders open</span><strong>38 orders</strong></div>
  </MiniWindow>
);

const Personalization = () => (
  <MiniWindow title="LIVE PERSONALIZATION" label="PREVIEW">
    <div className="ps-addon-personalization"><div className="ps-addon-shirt">👕<span>ELITE</span></div><div className="ps-addon-personalization-controls"><span>Logo placement</span><div className="ps-addon-input">ELITE</div><span>Position: Front chest</span><b>✓ Preview updated</b></div></div>
  </MiniWindow>
);

const Approval = () => (
  <MiniWindow title="PROOF APPROVAL" label="WORKFLOW">
    <div className="ps-addon-steps"><div>1 <span>Submitted</span><b>✓</b></div><div>2 <span>Client review</span><b className="ps-addon-checkmark">✓</b></div><div>3 <span>Approved</span><b className="ps-addon-checkmark">✓</b></div></div>
  </MiniWindow>
);

const Pricing = () => (
  <MiniWindow title="PROGRAM PRICING" label="VOLUME TIERS">
    <div className="ps-addon-price-grid"><span>QUANTITY</span><strong>100 → 250</strong><span>UNIT PRICE</span><strong className="ps-addon-price-change">$18.40 → $15.20</strong><span>PROTECTED MARGIN</span><strong>✓ 35%</strong></div>
    <div className="ps-addon-progress"><i/></div>
  </MiniWindow>
);

const Leads = () => (
  <MiniWindow title="LEAD CAPTURE" label="CORE SYNC">
    <div className="ps-addon-form-line">Name <b>Jordan Lee</b></div><div className="ps-addon-form-line">Email <b>jordan@example.com</b></div>
    <div className="ps-addon-submit">Submit inquiry <span>→</span></div><div className="ps-addon-status">✓ New lead added to Elite Core</div>
  </MiniWindow>
);

const Reorder = () => (
  <MiniWindow title="CLIENT RE-ORDER HUB" label="ORDER HISTORY">
    <div className="ps-addon-reorder"><span>🧢</span><div><strong>Team Cap</strong><small>Last ordered Aug 2026</small></div><b>REORDER ↗</b></div>
    <div className="ps-addon-status">✓ Added to reorder</div>
  </MiniWindow>
);

const Assistant = () => (
  <MiniWindow title="AI SALES ASSISTANT" label="RECOMMENDATIONS">
    <div className="ps-addon-chat">Build a welcome kit for 50 people</div>
    <div className="ps-addon-suggestion">✦ Suggested bundle <strong>Notebook + Cap + Bottle</strong></div>
    <div className="ps-addon-status">✓ Bundle ready to review</div>
  </MiniWindow>
);

const previews = { jersey: Jersey, store: Store, campaign: Campaign, personalization: Personalization, approval: Approval, pricing: Pricing, leads: Leads, reorder: Reorder, assistant: Assistant };

/** Roadmap-only demo. No data changes or addon activation occur here. */
export default function PromoShowcaseAddonPreview({ title }) {
  const [playing, setPlaying] = useState(false);
  const type = CARD_TYPES[title];
  const Preview = previews[type];
  if (!Preview) return null;
  return (
    <button
      type="button"
      className={"ps-addon-preview ps-addon-preview-" + type + (playing ? " ps-addon-preview-playing" : "")}
      onClick={() => setPlaying((current) => !current)}
      aria-label={title + " animated preview. " + (playing ? "Pause" : "Play") + " animation"}
      aria-pressed={playing}
      title="Hover to preview, or tap to play/pause"
    >
      <div className="ps-addon-preview-content"><Preview /></div>
      <span className="ps-addon-preview-hint">{playing ? "Pause preview" : "Hover to preview"}</span>
    </button>
  );
}
